/* eslint-disable @typescript-eslint/unbound-method */
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SerializableConverter_instances, _SerializableConverter_plugins, _SerializableConverter_fromSerializable, _SerializableConverter_deserializeError, _SerializableConverter_toSerializable, _a, _IsoError_hasCause, _IsoError_toIsoError;
//#region captureStackTrace polyfill
// istanbul ignore next
if (!Error.captureStackTrace) {
    Error.captureStackTrace = function (error) {
        const container = new Error();
        Object.defineProperty(error, 'stack', {
            configurable: true,
            get: function () {
                // Replace property with value for faster future accesses.
                defineStack(this, container.stack);
                return container.stack;
            },
            set: function (stack) { defineStack(error, stack); },
        });
    };
}
// istanbul ignore next
function defineStack(target, value) {
    Object.defineProperty(target, 'stack', {
        configurable: true,
        value,
        writable: true,
    });
}
export class SerializableConverter {
    constructor() {
        _SerializableConverter_instances.add(this);
        _SerializableConverter_plugins.set(this, []);
    }
    addPlugin(plugin) {
        __classPrivateFieldGet(this, _SerializableConverter_plugins, "f").unshift(plugin);
    }
    /**
     * Deserialize an `Error` from `Serializable`
     */
    fromSerializable(json, options) {
        const err = __classPrivateFieldGet(this, _SerializableConverter_instances, "m", _SerializableConverter_deserializeError).call(this, json);
        Error.captureStackTrace(err, options?.ssf);
        return err;
    }
    /**
     * Serialize `Error` to `Serializable`
     */
    toSerializable(err) {
        return __classPrivateFieldGet(this, _SerializableConverter_plugins, "f").reduce((p, s) => p || s.toSerializable(err), undefined) || __classPrivateFieldGet(this, _SerializableConverter_instances, "m", _SerializableConverter_toSerializable).call(this, err);
    }
}
_SerializableConverter_plugins = new WeakMap(), _SerializableConverter_instances = new WeakSet(), _SerializableConverter_fromSerializable = function _SerializableConverter_fromSerializable(json) {
    if (json.name === 'AggregateError') {
        const { message, errors, ...rest } = json;
        // @ts-ignore
        // istanbul ignore next
        if (global.AggregateError) {
            return Object.assign(new AggregateError(errors, message), rest);
        }
        else {
            return Object.assign(new Error(message), {
                ...rest,
                errors
            });
        }
    }
    const { message, cause, ...rest } = json;
    const causeError = cause ? __classPrivateFieldGet(this, _SerializableConverter_instances, "m", _SerializableConverter_deserializeError).call(this, cause) : undefined;
    if (json.name === 'Error') {
        return Object.assign(new Error(message), causeError ? { ...rest, cause: causeError } : rest);
    }
    // @ts-ignore
    return Object.assign(new IsoError(message, causeError ? { cause: causeError } : undefined), rest);
}, _SerializableConverter_deserializeError = function _SerializableConverter_deserializeError(json) {
    let err = undefined;
    for (const { fromSerializable } of __classPrivateFieldGet(this, _SerializableConverter_plugins, "f")) {
        err = fromSerializable(json);
        if (err)
            break;
    }
    return err || __classPrivateFieldGet(this, _SerializableConverter_instances, "m", _SerializableConverter_fromSerializable).call(this, json);
}, _SerializableConverter_toSerializable = function _SerializableConverter_toSerializable(err) {
    if (isAggregateError(err)) {
        return {
            ...err, name: err.constructor.name, message: err.message,
            errors: err.errors.map(__classPrivateFieldGet(this, _SerializableConverter_instances, "m", _SerializableConverter_toSerializable))
        };
    }
    if (err instanceof Error) {
        const { message, cause } = err;
        return cause
            ? { ...err, name: err.constructor.name, message, cause: __classPrivateFieldGet(this, _SerializableConverter_instances, "m", _SerializableConverter_toSerializable).call(this, cause) }
            : { ...err, name: err.constructor.name, message };
    }
    return err;
};
const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (_, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};
/**
 * Isomorphic Error that works across physical boundary.
 */
export class IsoError extends Error {
    /**
     * Create an IsoError with additional properties without the need to create a new class.
     * @param props properties of the IsoError
     */
    static create(props) {
        const { message, cause, ...rest } = props;
        const err = new IsoError(message, { cause, ssf: IsoError.create });
        return Object.assign(err, rest);
    }
    static stringify(err) {
        return this.serialize(err);
    }
    static serialize(err) {
        return JSON.stringify(this.toSerializable(err), getCircularReplacer());
    }
    static toSerializable(err) {
        return this.converter.toSerializable(err);
    }
    /**
     * @type P Additional properties of the IsoError
     * @param text Json representation of a IsoError
     */
    static parse(text) {
        const json = JSON.parse(text);
        return this.converter.fromSerializable(json, { ssf: IsoError.parse });
    }
    /**
     * @type P Additional properties of the IsoError
     * @param text Json representation of a IsoError
     */
    static deserialize(text) {
        const json = JSON.parse(text);
        return this.converter.fromSerializable(json, { ssf: IsoError.deserialize });
    }
    static fromSerializable(json) {
        return this.converter.fromSerializable(json, { ssf: IsoError.fromSerializable });
    }
    /**
     * returns the error message including the error causes.
     */
    static trace(err) {
        const messages = [];
        if (err instanceof ModuleError) {
            messages.push(`${err.name}(${err.module}): ${err.message}`);
        }
        else if (err instanceof Error) {
            messages.push(`${err.name}: ${err.message}`);
        }
        if (isAggregateError(err)) {
            err.errors.forEach(e => messages.push(...this.trace(e).split('\n').map(s => '  ' + s)));
        }
        if (err instanceof Error) {
            if (__classPrivateFieldGet(this, _a, "m", _IsoError_hasCause).call(this, err))
                messages.push(...this.trace(err.cause).split('\n').map(s => '  ' + s));
        }
        else {
            messages.push(typeof err === 'string' ? err : JSON.stringify(err));
        }
        return messages.join('\n');
    }
    static addPlugin(plugin) {
        this.converter.addPlugin(plugin);
    }
    constructor(message, options) {
        super(message);
        /**
         * Name of the error
         */
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        /**
         * Error cause
         */
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // restore prototype chain
        const actualProto = new.target.prototype;
        this.name = actualProto.constructor.name;
        // istanbul ignore next
        if (Object.setPrototypeOf)
            Object.setPrototypeOf(this, actualProto);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        else
            this.__proto__ = actualProto;
        if (options?.cause)
            this.cause = __classPrivateFieldGet(IsoError, _a, "m", _IsoError_toIsoError).call(IsoError, options.cause);
        if (options?.ssf)
            Error.captureStackTrace(this, options.ssf);
    }
    toString() { return IsoError.serialize(this); }
    trace() { return IsoError.trace(this); }
}
_a = IsoError, _IsoError_hasCause = function _IsoError_hasCause(x) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return !!x.cause;
}, _IsoError_toIsoError = function _IsoError_toIsoError(err) {
    // When the error is an internal error from deserialization,
    // the err.constructor.name is object.
    // I have to to Object.assign to keep the err instance and its stack trace.
    return Object.assign(err, { name: err.name ?? err.constructor.name });
};
Object.defineProperty(IsoError, "converter", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: new SerializableConverter()
});
/**
 * An IsoError with a module property.
 */
export class ModuleError extends IsoError {
    /**
     * @param module The module that defines this error.
     */
    constructor(module, message, options) {
        super(message, options);
        Object.defineProperty(this, "module", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: module
        });
    }
}
export function isAggregateError(error) {
    return error instanceof Error && Array.isArray(error.errors);
}
//# sourceMappingURL=index.js.map